"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: 'auto',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'rgba(206, 31, 36, 0.04)',
        border: '1px solid',
        borderColor: theme.palette.primary.main
      }
    },
    icon: {
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main
      }
    }
  };
}, {
  name: 'SelectMultipleValueChips'
});

function SelectMultipleValueChips(_ref) {
  var chipColor = _ref.chipColor,
      pClasses = _ref.classes,
      className = _ref.className,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["chipColor", "classes", "className", "label", "onChange", "options", "value"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var handleChange = _react.default.useCallback(function (v) {
    return function () {
      var vv = value || [];
      var i = vv.indexOf(v);
      var nextV = i >= 0 ? [].concat((0, _toConsumableArray2.default)(vv.slice(0, i)), (0, _toConsumableArray2.default)(vv.slice(i + 1))) : vv;
      onChange(nextV);
    };
  }, [onChange, value]);

  return options && options.length ? options.map(function (o, index) {
    return /*#__PURE__*/_react.default.createElement(_Chip.default, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      label: "".concat(t(label, {
        acceptString: true
      }), ": ").concat(t(o.label, {
        acceptString: true
      })),
      onDelete: handleChange(o.value),
      deleteIcon: /*#__PURE__*/_react.default.createElement(_Close.default, {
        className: classes.icon
      }),
      color: chipColor,
      variant: "outlined",
      key: index.toString()
    }, rest));
  }) : null;
}

process.env.NODE_ENV !== "production" ? SelectMultipleValueChips.propTypes = {
  chipColor: _propTypes.default.string,
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  value: _propTypes.default.arrayOf(_propTypes.default.string)
} : void 0;
SelectMultipleValueChips.defaultProps = {
  chipColor: undefined,
  classes: undefined,
  className: undefined,
  label: undefined,
  onChange: undefined,
  options: undefined,
  value: undefined
};
var _default = SelectMultipleValueChips;
exports.default = _default;